import { useTheme } from '@mui/material/styles';
import { Button, Grid, Typography, useMediaQuery, useThemeProps } from '@mui/material';
import Box from '@mui/material/Box';
import Image from 'mui-image';
import { useEffect, useState } from 'react';
import { useSpring, animated, useTrail } from "react-spring";

const AnimatedImage = animated(Image);
const AnimatedTypo = animated(Typography);

export default function Project(props) {

    var leave = props.leave;
    // var leave;

    const trail1 = useTrail(1, {
        config: { mass: 5, tension: 2000, friction: 200 },
        opacity: leave ? 1 : 0,
        x: 0,
        y: leave ? 0 : -50,
        height: leave ? 110 : 0,
        from: { opacity: 0, x: -50, height: 0 },
    })
    const trail2 = useTrail(1, {
        config: { mass: 5, tension: 2000, friction: 200 },
        opacity: leave ? 1 : 0,
        x: leave ? 0 : -50,
        height: leave ? 110 : 0,
        from: { opacity: 0, x: 50, height: 0 },
    })
    const trail3 = useTrail(1, {
        config: { mass: 5, tension: 2000, friction: 200 },
        opacity: leave ? 1 : 0,
        x: 0,
        y: leave ? 0 : 50,
        height: leave ? 110 : 0,
        from: { opacity: 0, x: 50, height: 0 },
    })
    const imageTrail = useTrail(1, {
        config: { duration: 300 },
        opacity: leave ? 1 : 0,
    })

    useEffect(() => {
        setTimeout(() => { leave = false; }, 500);
        setTimeout(() => { leave = true; }, 1000);
    }, [props]);

    const theme = useTheme();
    const mobileView = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box className="no-overflow" key={props.counter} sx={{ flexGrow: 1, display: { xs: 'block',md:"flex" ,lg: 'flex' }, m: { xs: 0,md: "auto" ,lg: "auto" }, justifyContent: { xs: "left", md: "left", lg: "left" }, alignContent: "center", alignItems: { xs: "center",md: "center" ,lg: "center" }, height: "100%" }}>
            <Box className="no-overflow" sx={{ display: { xs: 'flex', md: "flex", lg: 'flex' }, flexDirection: { xs: "column" }, textAlign: { xs: "center",md: "left" ,lg: "left" }, color: "white", height: "100%", alignItems: { xs: "center",md: "center", lg: "center" }, m: { sx: "0", md: "0",lg: "0" } }}>
                {trail1.map(({ height, ...style }, index) => (
                    <AnimatedTypo className="no-overflow" variant="h3" sx={{
                        display: { xs: 'block', md: "flex", lg: 'flex' },
                        fontFamily: 'Title',
                        fontSize: { xs: 20, md: 35, lg: 35 },
                        fontWeight: 600,
                        letterSpacing: '.2rem',
                        color: 'inherit',
                        textDecoration: 'none',
                        textAlign: { xs: "center", md: "left", lg: "left" },
                        textTransform: "capitalize",
                        maxWidth: { xs: "30vw", md: "30vw", lg: "30vw" },
                        maxHeight: { xs: "30vh" },
                        mb: { xs: "1rem",md:"0.5rem" ,lg: "0.5rem" },
                        alignSelf: { xs: "center",md:"flex-start", lg: "flex-start" }
                    }} style={style} gutterBottom
                    >{props.title}</AnimatedTypo>
                ))}
                {trail2.map(({ height, ...style }, index) => (
                    <AnimatedTypo className="no-overflow" sx={{
                        display: { xs: 'block', md: "flex", lg: 'flex' },
                        fontFamily: 'Title',
                        fontSize: { xs: "1rem",md: "1.5rem" ,lg: "1.5rem" },
                        fontWeight: 300,
                        letterSpacing: '.1rem',
                        color: 'inherit',
                        textDecoration: 'none',
                        textAlign: { xs: "center", md: "left", lg: "left" },
                        textTransform: "capitalize",
                        maxWidth: { xs: "30vw", md: "30vw", lg: "30vw" },
                        maxHeight: { xs: "30vh" },
                        mb: { xs: "1rem" },
                        alignSelf: { xs: "center",md:"flex-start", lg: "flex-start" }
                    }} style={style} gutterBottom>{props.domain}</AnimatedTypo>
                ))}
                {trail3.map(({ height, ...style }, index) => (
                    <AnimatedTypo className="no-overflow" sx={{
                        display: { xs: 'block', md: "flex", lg: 'flex' },
                        fontFamily: 'Title',
                        fontSize: { xs: "0.75rem",md: "1.2rem" ,lg: "1.2rem" },
                        // fontWeight: 700,
                        letterSpacing: '.1rem',
                        color: 'inherit',
                        textDecoration: 'none',
                        textAlign: { xs: "center", md: "left" ,lg: "left" },
                        textTransform: "capitalize",
                        maxWidth: { xs: "30vw", md: "30vw",lg: "30vw" },
                        maxHeight: { xs: "45vh" },
                        mb: { xs: "1rem" },
                        alignSelf: { xs: "center",md:"flex-start", lg: "flex-start" }
                    }} style={style}>{props.desc}</AnimatedTypo>
                ))}
            </Box>
            {imageTrail.map(({ ...style }, index) => (
                <a href={props.linkRef}>
                    <AnimatedImage className="no-overflow" src={props.image} sx={{ p: { xs: 2 }, transition: "none !important", maxWidth: { xs: "25rem",md:"45rem" ,lg: "45rem" } }} style={style} />
                </a>
            ))}
        </Box>
    );
}